import React, { useState } from 'react';
import { useAuth } from '../hooks/useAuth';
import RouteList from '../components/routes/RouteList';
import CreateRoute from '../components/routes/CreateRoute';
import TripList from '../components/trips/TripList';
import CreateTrip from '../components/trips/CreateTrip';
import TripRequestManager from '../components/trips/TripRequestManager';
import DashboardNavigation from '../components/layout/DashboardNavigation';

type DashboardView = 'routes' | 'trips' | 'create-route' | 'create-trip' | 'requests';

const Dashboard: React.FC = () => {
  const [activeView, setActiveView] = useState<DashboardView>('routes');
  const [selectedTripId, setSelectedTripId] = useState<number | null>(null);
  const { user, logout } = useAuth();

  const handleViewChange = (view: DashboardView) => {
    setActiveView(view);
    if (view !== 'requests') {
      setSelectedTripId(null);
    }
  };

  const renderContent = () => {
    switch (activeView) {
      case 'routes':
        return <RouteList />;
      
      case 'create-route':
        return (
          <CreateRoute
            onRouteCreated={() => handleViewChange('routes')}
            onCancel={() => handleViewChange('routes')}
          />
        );
      
      case 'trips':
        return <TripList />;
      
      case 'create-trip':
        return (
          <CreateTrip
            onTripCreated={() => handleViewChange('trips')}
            onCancel={() => handleViewChange('trips')}
          />
        );
      
      case 'requests':
        return selectedTripId ? (
          <TripRequestManager
            tripId={selectedTripId}
            onClose={() => {
              handleViewChange('trips');
              setSelectedTripId(null);
            }}
          />
        ) : (
          <div className="text-center py-8">
            <p className="text-gray-500">No trip selected for request management</p>
          </div>
        );
      
      default:
        return <RouteList />;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <DashboardNavigation 
        activeView={activeView}
        onViewChange={handleViewChange}
        user={user}
        onLogout={logout}
      />
      <main className="py-6">
        {renderContent()}
      </main>
    </div>
  );
};

export default Dashboard;